import { render } from "./proposal-details-check-diy.vue?vue&type=template&id=920d3534&scoped=true"
import script from "./proposal-details-check-diy.vue?vue&type=script&lang=js"
export * from "./proposal-details-check-diy.vue?vue&type=script&lang=js"

import "./proposal-details-check-diy.vue?vue&type=style&index=0&id=920d3534&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-920d3534"]])

export default __exports__